<div
  id="sidenavBackdrop"
  class="overlay-content-backdrop sidenav-backdrop"
></div>
<div
  id="overlay"
  class="overlay overlay-left side-nav-wrapper"
  [ngClass]="{
    'dynamic-header-height-top': !isMobile,
  }"
>
  <div class="overlay-content">
    <div class="head-section">
      <app-button
        #closeBtn
        buttonId="hamburgerMenuCloseBtn"
        (clickEvent)="close()"
        [hasIcon]="true"
        [iconClassName]="'cm-icons-close'"
        automationAttribute="navigation_CloseHamburger"
        text=""
        variation="link"
        [getTextFromCMS]="false"
        className="close-btn"
        [ariaLabel]="'close_button' | content"
      >
      </app-button>
      <h2 class="panel-title underline">{{ "lbl_header_menu" | content }}</h2>
    </div>
    <div class="body-section">
      <nav [attr.aria-label]="'lbl_header_menu' | content">
        <mat-accordion role="menu">
          @for (menuItem of menuItems; track menuItem) {
            <mat-expansion-panel
              class="side-nav-panel"
              [hideToggle]="menuItem?.components?.length === 0"
            >
              <mat-expansion-panel-header
                class="side-nav-panel-header"
                (click)="
                  onMenuItemClick(menuItem);
                  tagOnNavClick(menuItem.routerLink, menuItem.analyticLabel)
                "
                role="menuitem"
                [ngClass]="{
                  'no-sub-menu': menuItem?.components?.length === 0,
                }"
              >
                <mat-panel-title>
                  <div role="heading" class="side-nav-menu-item" aria-level="2">
                    {{ menuItem.label | content }}
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul role="menu">
                @for (item of menuItem?.components; track item) {
                  <li role="none">
                    <button
                      class="side-nav-menu-item-inner"
                      role="menuitem"
                      (click)="
                        onMenuItemClick(item);
                        tagOnNavClick(
                          item.routerLink,
                          menuItem.analyticLabel,
                          item.analyticLabel
                        )
                      "
                    >
                      <span class="ham-menu-item-wrapper">
                        <span class="ham-menu-item-content">
                          {{ item.label | content }}</span
                        >
                        <i
                          class="cm-icons cm-icons-angle-right"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                  </li>
                }
              </ul>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </nav>
    </div>
  </div>
</div>
